export default __webpack_public_path__ + "static/media/512.59bf4e2a.png";